module.exports = __webpack_public_path__ + "media/images/icon_dl-ed3bc62864728fec3fe8495fdaf72d1e.svg";